import { AppTheme } from "@hex/common";
import React from "react";

import { HexMenuDivider, HexMenuItem } from "../../hex-components";
import { LocalStorageKeys, useLocalStorage } from "../../hooks/useLocalStorage";
import { usePrefersColorScheme } from "../../hooks/usePrefersColorScheme";
import { THEME_DISPLAY_NAMES } from "../../theme/common/theme";
import { trackCounterEvent } from "../../util/trackEvent";
import { PreferencesIcon, TickIcon } from "../icons/CustomIcons";

interface QuickSettingsProps {
  flatten?: boolean;
  location?: "popover_sidebar" | "home_sidebar";
}

export const QuickSettings: React.FunctionComponent<QuickSettingsProps> = ({
  flatten = false,
  location,
}) => {
  const preferredColorScheme = usePrefersColorScheme();
  const [themeName, toggleTheme] = useLocalStorage(LocalStorageKeys.THEME_NAME);

  const contents = (
    <>
      <HexMenuDivider title="Theme" />
      <HexMenuItem
        labelElement={themeName === AppTheme.SYS_PREF ? <TickIcon /> : ""}
        shouldDismissPopover={false}
        text={`System (${THEME_DISPLAY_NAMES[preferredColorScheme]})`}
        onClick={() => {
          toggleTheme(AppTheme.SYS_PREF);
          location &&
            trackCounterEvent(`${location}.user_menu.theme.system.click`);
        }}
      />
      <HexMenuItem
        labelElement={themeName === AppTheme.LIGHT ? <TickIcon /> : ""}
        shouldDismissPopover={false}
        text="Light"
        onClick={() => {
          toggleTheme(AppTheme.LIGHT);
          location &&
            trackCounterEvent(`${location}.user_menu.theme.light.click`);
        }}
      />
      <HexMenuItem
        labelElement={themeName === AppTheme.DARK ? <TickIcon /> : ""}
        shouldDismissPopover={false}
        text="Dark"
        onClick={() => {
          toggleTheme(AppTheme.DARK);
          location &&
            trackCounterEvent(`${location}.user_menu.theme.dark.click`);
        }}
      />
    </>
  );

  if (flatten) {
    return contents;
  }

  return (
    <HexMenuItem icon={<PreferencesIcon />} text="Preferences">
      {contents}
    </HexMenuItem>
  );
};
